export default function (Site, $) {
  Site.widget('auto-tabs', {
    _create () {
      this.autoTabs()
    },
    autoTabs () {

      var time = 6000;

      var timer = new Timer(function() {
          var $currentTab = $('.tabs li.active')
          var $nextTab = $currentTab.next('li')

          if( $nextTab.length == 0 ) {
            $nextTab = $currentTab.prevAll('li').last()
          }

          $currentTab.removeClass('active')
          $nextTab.addClass('active')

          var $currentSection = $('.autotab-section.active')
          var $nextSection = $currentSection.next('.autotab-section')

          if( $nextSection.length == 0 ) {
            $nextSection = $currentSection.prevAll('.autotab-section').last()
          }

          $currentSection.removeClass('active')
          $nextSection.addClass('active')
      }, time)

      timer.start();
 
      this.element.find('.tabs li').on('click', (e) => {
        this.element.find('.tabs li').removeClass('active')
        $(e.currentTarget).addClass('active')
        var newTab = $(e.currentTarget).data('tab')
        this.element.find('.autotab-section').removeClass('active')
        this.element.find('.autotab-section[data-section="'+newTab+'"]').addClass('active')

        timer.reset(time)
      })
    },
  })
}

function Timer(fn, t) {
    var timerObj = setInterval(fn, t);

    this.stop = function() {
        if (timerObj) {
            clearInterval(timerObj);
            timerObj = null;
        }
        return this;
    }

    this.start = function() {
        if (!timerObj) {
            this.stop();
            timerObj = setInterval(fn, t);
        }
        return this;
    }

    this.reset = function(newT) {
        t = newT;
        return this.stop().start();
    }
}